__turbopack_context__.v({
  "blockCardSwipe": "BlockCardSwipe-module-scss-module__-xeNfW__blockCardSwipe",
  "cards": "BlockCardSwipe-module-scss-module__-xeNfW__cards",
  "cover": "BlockCardSwipe-module-scss-module__-xeNfW__cover",
  "customIcon": "BlockCardSwipe-module-scss-module__-xeNfW__customIcon",
  "fade-in": "BlockCardSwipe-module-scss-module__-xeNfW__fade-in",
  "iconContainer": "BlockCardSwipe-module-scss-module__-xeNfW__iconContainer",
  "image": "BlockCardSwipe-module-scss-module__-xeNfW__image",
  "inner": "BlockCardSwipe-module-scss-module__-xeNfW__inner",
  "isInView": "BlockCardSwipe-module-scss-module__-xeNfW__isInView",
  "isShifting": "BlockCardSwipe-module-scss-module__-xeNfW__isShifting",
  "nav": "BlockCardSwipe-module-scss-module__-xeNfW__nav",
  "navCount": "BlockCardSwipe-module-scss-module__-xeNfW__navCount",
  "navItem": "BlockCardSwipe-module-scss-module__-xeNfW__navItem",
  "ourCulture": "BlockCardSwipe-module-scss-module__-xeNfW__ourCulture",
});
